import { render, staticRenderFns } from "./indexlists.vue?vue&type=template&id=a499dcfe"
import script from "./indexlists.vue?vue&type=script&lang=js"
export * from "./indexlists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports